export default class State {
	constructor(parent) {
		this._parent = parent
	}
	Enter() {}
	Exit() {}
	Update() {}
}
